import "@stripe/stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { isBrowser } from "./firebase"

export async function initializeStripe() {
  if (isBrowser) {
    const publishableKey = "pk_live_mex4o9oqej8tvbnmgnHHuB18"
    const stripe = await loadStripe(publishableKey)

    return stripe
  } else {
    return null
  }
}
